import request from '../../js/lib/request';
import currentLang from '../../js/lib/currentLang';
import envVar from '../../js/lib/envVar';
import raf from '../../js/lib/raf';
import urlVars from '../../js/lib/urlVars';

const animateScroll = (el,scrollTargetX) => {
	let scrollX = el.scrollLeft;
	let speed = 300;
	let easing = function easeInOutQuint(pos) {
		if ((pos /= 0.5) < 1) {
			return 0.5 * Math.pow(pos, 5);
		}
		return 0.5 * (Math.pow((pos - 2), 5) + 2);
	};
	let currentTime = 0;

	// min time .1, max time .8 seconds
	let time = Math.max(.1, Math.min(Math.abs(scrollX - scrollTargetX) / speed, .8));

	// add animation loop
	function tick() {
		currentTime += 1 / 60;
		var p = currentTime / time;
		var t = easing(p);
		if (p < 1) {
			raf(tick);
			el.scrollLeft = scrollX + ((scrollTargetX - scrollX) * t);
		} else {
			el.scrollLeft = scrollTargetX;
		}
	}
	// call it once to get started
	tick();
};

if (document.getElementById('cards')) {
	// Use different URL for Static/MVC
	const url = envVar({
		backendPath:'/CategoryCards/?lang=' + currentLang(),
		staticPath: 'js/data/cards.json'
	});

	request().get(url).then(function(response) {
		// Vue Component
		const cards = new Vue({
			// cards Element ~> this.$el
			el: '#cards',
			// Define Schema ~> set to null/0
			data: {
				categories: '',
				cards: '',
				currentCatId: '',
			},
			// When Component is Mounted, run Methods
			mounted: function() {
				const self = this;
				self.loadCategories();
				self.checkUrl();

				if(window.addEventListener)
				{
					window.addEventListener('popstate', function(event) {
						self.checkUrl();
					});
				}
				
			},
			// Methods
			methods: {
				// Load Primary Menu
				// Only happends when 
				// Component is Mounted
				loadCategories: function() {
					const self = this;
					self.categories = response;
				},
				loadMore: function(lang) {
					const self = this;

					document.location.href = '/' + lang + '/search/?c=' + self.currentCatId;
				},
				loadCards: function(index, event) {
					const self = this;
					self.cards = self.categories[index].content;

					// removes selected link style
					Vue.nextTick(function() {
						for (var i = 0; i < self.$refs.navigationLink.length; i++) {
							self.$refs.navigationLink[i].removeAttribute('selected');
						}

						self.$refs.navigationLink[index].setAttribute('selected', true);

						// Animate the Scroll on mobile
						animateScroll(self.$refs.navigation, self.$refs.navigationLink[index].offsetLeft - 40);
					});

					// Card Loading Animations handled in CSS
					self.$el.setAttribute('data-loading',true);
					setTimeout(()=>{
						self.$el.setAttribute('data-loading',false);
					},50);
					self.$el.setAttribute('data-state', self.categories[index].title);

					// if we got a click, pop a history state to the browser so we have back button functionality
					if(event)
					{
						if(window.history.pushState)
							window.history.pushState({'html':response},'', '?featured=' + index);
					}

					self.currentCatId = self.categories[index].id;
				},
				checkUrl: function(index, event) {
					const self = this;

					// check featured url var
					var qs = urlVars();
					if(qs['featured'])
						self.loadCards(qs['featured']);
					else
						self.loadCards(0);
				},

			}
		});
	});
}



// WEBPACK FOOTER //
// ../components/cards/cards.js